import { useState } from "react";
import { useTypedParams } from "react-router-typesafe-routes";

import { ExtensionInstructionsCard } from "@components/Cards";

import { Tabs } from "@design-system/Tabs/Tabs";

import { PortalSubNavigation } from "@layouts/PortalPage/PortalSubNavigation";

import { routes } from "@pages/routes";

export const ExtensionInstallation = () => {
  const { clientId } = useTypedParams(routes.portal.clients.client);
  const [activeTab, setActiveTab] = useState<"windows" | "mac">("windows");

  return (
    <>
      <PortalSubNavigation>
        <div
          style={{
            padding: "0 24px",
            backgroundColor: "var(--background-default-primary)",
            borderBottom: "1px solid var(--border-default-primary)",
            display: "flex",
            alignItems: "flex-end",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <Tabs style={{ borderBottom: "none", gap: "24px" }}>
            <Tabs.Tab
              icon="faWindows"
              name="Windows"
              isActive={activeTab === "windows"}
              onClick={() => setActiveTab("windows")}
            />
            <Tabs.Tab
              icon="faApple"
              name="macOS"
              isActive={activeTab === "mac"}
              onClick={() => setActiveTab("mac")}
            />
          </Tabs>
        </div>
      </PortalSubNavigation>
      <ExtensionInstructionsCard clientId={clientId} os={activeTab} />
    </>
  );
};
